import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { BlogSlider } from "../../../shared/data/slider";
import { EcomerceService } from "src/app/shared/services/ecommerce.service";
import { LocalStorageService } from "src/app/shared/services/localStorage.service";
import { OwlCarousel } from 'ngx-owl-carousel';

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
  @Input() blogs: any[] = [];
  public BlogSliderConfig: any = BlogSlider;

  usuarioLogado: any;

  @ViewChild('owlElement') owlElement: OwlCarousel;

  constructor(
    public ecomerceService: EcomerceService,
    public localStorageService: LocalStorageService
  ) {
    this.usuarioLogado = this.localStorageService.get("usuarioLogado");
  }

  ngOnInit() {
    this.getBlogsAPI();
  }

  getBlogsAPI() {
    this.ecomerceService.listar(11).subscribe(
      (data) => {
        this.blogs = data;
      },
      (err) => {}
    );
  }

  nextSlide() {
    this.owlElement.next();
  }

  prevSlide() {
    this.owlElement.previous();
  }
}
